import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=cdec756a&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"
import style0 from "./studentList.vue?vue&type=style&index=0&id=cdec756a&prod&lang=less&scoped=true"
import style1 from "./studentList.vue?vue&type=style&index=1&id=cdec756a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdec756a",
  null
  
)

export default component.exports